import React, { useRef, useState, useEffect, forwardRef } from "react";
import { NavLink } from "react-router";
import { RoutesPaths } from "../Router/constant";
import { getAdminProfile } from "../Services/userService";
import { getNotifications, getPartnerNotifications, markNotificationAsRead } from "../Services/dashboardService";
import { useNavigate } from "react-router-dom";

const Header = forwardRef(({ onHeaderClick }, ref) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const notificationIconRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [profileImage, setProfileImage] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [loadingNotifications, setLoadingNotifications] = useState(true);
  const [selectedNotificationId, setSelectedNotificationId] = useState(null);
  const userRole = localStorage.getItem("userRole")

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getAdminProfile();
        const adminData = res.data?.data?.admin || res?.data?.data?.user;

        const admin = Array.isArray(adminData) ? adminData[0] : adminData;
        setProfileImage(admin?.profileImage || "");
      } catch (err) {
        console.error("Error fetching profile:", err);
      } finally {
        setLoading(false);
      }
    };

    const fetchNotifications = async () => {
      try {
        let res;
        if (userRole === "admin") {
          res = await getNotifications();
        } else {
          res = await getPartnerNotifications();
        }
        if (res?.data?.success) {
          setNotifications(res.data.data || []);
        }
      } catch (err) {
        console.error("Error fetching notifications:", err);
      } finally {
        setLoadingNotifications(false);
      }
    };

    fetchProfile();
    fetchNotifications();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        notificationIconRef.current &&
        !notificationIconRef.current.contains(e.target)
      ) {
        setShowNotifications(false);
      }
    };


    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [showNotifications]);

  const toggleNotifications = () => setShowNotifications((prev) => !prev);

  const formatTimeAgo = (dateString) => {
    const seconds = Math.floor((Date.now() - new Date(dateString)) / 1000);
    const intervals = [
      { label: "year", seconds: 31536000 },
      { label: "month", seconds: 2592000 },
      { label: "day", seconds: 86400 },
      { label: "hour", seconds: 3600 },
      { label: "minute", seconds: 60 },
      { label: "second", seconds: 1 },
    ];

    for (const { label, seconds: s } of intervals) {
      const count = Math.floor(seconds / s);
      if (count >= 1) return `${count} ${label}${count > 1 ? "s" : ""} ago`;
    }

    return "just now";
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case 10: return "New user registered";
      case 9: return "Order assigned";
      case 8: return "Contract uploaded";
      case 7: return "Quotation created";
      case 5: return "Order created";
      case 4: return "Support request";
      default: return "General notification";
    }
  };


  const handleNotificationClick = async (item) => {
    setSelectedNotificationId(item._id);
    setShowNotifications(false);
    if (!item.isRead) {
      try {
        await markNotificationAsRead(item._id);

        setNotifications((prev) =>
          prev.map((n) =>
            n._id === item._id ? { ...n, isRead: true } : n
          )
        );
      } catch (err) {
        console.error("Failed to mark notification as read", err);
      }
    }
    switch (item.type) {
      case 4:
        navigate("/contact-support");
        break;

      case 5:
        if (userRole === "admin" && item.order) {
          navigate(`/booking-management/order-history/${item.order}`);
        }
        break;

      case 8:
        if (userRole === "partner") {
          navigate("/partners/detail/agreement");
        }
        break;

      case 9:
        if (userRole === "partner") {
          navigate(`/booking-management/order-history/${item.order}`);
        }
        break;
      
      case 10:
        if (userRole === "admin") {
          navigate(RoutesPaths.USERMANAGEMENT);
        }
        break;

      default:
        break;
    }
  };


  const filteredNotifications = notifications.filter((item) => {
    if (userRole === "admin") {
      return true;
    }

    if (userRole === "partner") {
      return item.type === 4 || item.type === 8 || item.type === 9;
    }

    return false;
  });

  const unreadCount = notifications.filter(n => !n.isRead).length;

  return (
    <div
      className={`headerSection ${userRole === "partner" ? "headerSectionPartner" : ""
        }`}
    >      <div className="mobileView" ref={ref} onClick={onHeaderClick}>
        <img src="/assets/img/threeline.svg" alt="" className="threelineIcon" />
        <img src="/assets/img/quimeraLogo.svg" alt="Quimera Logo" />
      </div>

      <div className="m-0 mobileHide">
        {/* <div className="searchSideBar m-0 mobileHide"> */}
        {/* <img src="/assets/img/search.svg" alt="" /> */}
        {/* <input type="text" placeholder="Search" /> */}
      </div>

      <div className="headerRightSec">
        {/* <div className="countryFlag mobileHide">
          <img src="https://flagcdn.com/48x36/in.png" alt="IN Flag" />
        </div> */}
        {userRole === 'admin' &&
          <div className="headerIconSection mobileHide">
            <NavLink to={RoutesPaths.USERMANAGEMENT}>
              {userRole === "partner" ? <img src="/assets/img/usersPartner.svg" alt="Users" /> : <img src="/assets/img/users.svg" alt="Users" />}
            </NavLink>
          </div>
        }

        <div
          className="headerIconSection notificationSection mobileHide"
          onClick={toggleNotifications}
          ref={notificationIconRef}
        >
          <div className="notificationIconWrapper">
            <img
              src={
                userRole === "partner"
                  ? "/assets/img/notificationPartner.svg"
                  : "/assets/img/notification.svg"
              }
              alt="Notification"
            />

            {unreadCount > 0 && (
              <span className="notificationBadge">{unreadCount}</span>
            )}
          </div>
        </div>


        <NavLink to={RoutesPaths.PROFILE}>
          <div className="userImage">
            {loading ? (
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  backgroundColor: "#e0e0e0",
                  animation: "pulse 1.5s infinite",
                }}
              />
            ) : (
              <img
                src={
                  profileImage
                    ? `${process.env.REACT_APP_IMAGE_URL}/${profileImage}`
                    : "/assets/img/download.png"
                }
                alt="User"
              />
            )}

          </div>
        </NavLink>

        {showNotifications && (
          <div className="userDropdown" ref={dropdownRef}>
            <img className="notificationArrow" src="/assets/img/arrowup.svg" alt="arrow" />
            <h4 className="headerTextNotification">Notification</h4>

            <div className="notificationScrollSection">
              {loadingNotifications ? (
                <p className="text-center py-3 m-0">Loading...</p>
              ) : filteredNotifications.length > 0 ? (
                filteredNotifications.map((item, index) => (
                  <div key={index} className={`notificationCard  ${!item.isRead ? "unreadNotification" : "readNotification"} ${selectedNotificationId === item._id ? "selectedNotification" : ""
                    }`} onClick={() => handleNotificationClick(item)}
                  >

                    <img
                      src={item?.user?.profileImage ? `${process.env.REACT_APP_IMAGE_URL}/${item?.user?.profileImage}` : "/assets/img/default-profile.svg"}
                      alt="User"
                      width={40}
                      height={40}
                      className="rounded-circle"
                    />
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between">
                        <div className="fw-semibold">{getTypeLabel(item.type)}</div>
                        <div className="text-muted small">{formatTimeAgo(item.createdAt)}</div>
                      </div>
                      <div className="text-muted small">{item.email || "—"}</div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center py-3 m-0">No notifications found</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default Header;
